export enum TranslationEnum {
  HOMEPAGE = 'homepage',
  ENERGIA = 'energia',
  NOTFOUND = 'notFound',
  ALREADY_INSURED = 'alreadyInsured',
  GENERIC_ERROR = 'genericError',
  QUOTATION_ERROR = 'quotationError',
  PAYMENT_ERROR = 'paymentError',
  DISSERVICE = 'disservice',
  ALLIANZ_PAY = 'allianzPay',
  ALLIANZ_PAY_INVALID_CODE = 'allianzPayInvalidCode'
}
